import { configureStore } from "@reduxjs/toolkit";
import waiting from "./waiting";

export const store = configureStore({
    reducer: {
        waiting: waiting,
    },
});
